import React from "react";
import { DailyChallenge } from "../core";
import { PlayGameMeta } from "../core/types";

export interface DailyChallengeCardProps {
  challenge: DailyChallenge;
  game?: PlayGameMeta;
  onPlay?: () => void;
}

export const DailyChallengeCard: React.FC<DailyChallengeCardProps> = ({ challenge, game, onPlay }) => {
  return (
    <div className="mm-surface p-4 space-y-2">
      <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
        Défi du jour · {challenge.dateKey}
      </p>
      <h3 className="text-lg font-semibold">{challenge.title}</h3>
      <p className="text-sm text-slate-600 dark:text-slate-300">{challenge.shortDescription}</p>
      {game && (
        <p className="text-xs text-slate-500 dark:text-slate-400">
          Catégorie: {game.category} · Difficulté: {game.difficulty}
        </p>
      )}
      <button
        type="button"
        onClick={onPlay}
        className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
      >
        Lancer le défi
      </button>
    </div>
  );
};
